import { render, staticRenderFns } from "./button-collapse.vue?vue&type=template&id=55bb3688&scoped=true"
import script from "./button-collapse.ts?vue&type=script&lang=ts&external"
export * from "./button-collapse.ts?vue&type=script&lang=ts&external"
import style0 from "./button-collapse.vue?vue&type=style&index=0&id=55bb3688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bb3688",
  null
  
)

export default component.exports